(function () {
  if (window.__autoDiscountFrontInit) return;
  window.__autoDiscountFrontInit = true;

  var STOREFRONT_TOKEN = '6ac47ac0a3d269b60000920c21a171e7';

  function toInstallmentNumber(value) {
    if (value == null) return NaN;
    if (typeof value === 'number') {
      if (!Number.isFinite(value) || value <= 0) return NaN;
      if (Number.isInteger(value) && value >= 1000) return value / 100;
      return value;
    }

    var raw = String(value).trim();
    if (!raw) return NaN;

    var hasDecimalSeparator = raw.indexOf(',') > -1 || raw.indexOf('.') > -1;
    var numeric = raw.replace(/[^\d,.-]/g, '').replace(/\s+/g, '');
    if (!numeric) return NaN;

    var normalized = numeric;
    if (numeric.indexOf(',') > -1) {
      normalized = numeric.replace(/\./g, '').replace(',', '.');
    }

    var parsed = parseFloat(normalized);
    if (!Number.isFinite(parsed) || parsed <= 0) return NaN;

    // Alguns apps retornam em centavos (ex.: 3990 = R$ 39,90).
    if (!hasDecimalSeparator && /^-?\d+$/.test(numeric) && parsed >= 1000) {
      parsed = parsed / 100;
    }

    return Number.isFinite(parsed) ? parsed : NaN;
  }

  function resolvePagBrasilInstallmentMinValue() {
    var candidates = [
      window.PAGBRASIL_INSTALLMENT_MIN_VALUE,
      window.PAGBRASIL_MIN_INSTALLMENT_VALUE,
      window.PAGBRASIL_MIN_INSTALLMENT_AMOUNT,
      window.PagBrasilInstallmentMinValue,
      window.pagbrasilInstallmentMinValue,
      window.PagBrasil && window.PagBrasil.installmentMinValue,
      window.PagBrasil && window.PagBrasil.minInstallmentValue,
      window.PagBrasil && window.PagBrasil.minInstallmentAmount,
      window.PagBrasil && window.PagBrasil.config && window.PagBrasil.config.installmentMinValue,
      window.pagBrasil && window.pagBrasil.installmentMinValue,
      window.pagBrasil && window.pagBrasil.minInstallmentValue
    ];

    for (var i = 0; i < candidates.length; i++) {
      var parsed = toInstallmentNumber(candidates[i]);
      if (Number.isFinite(parsed) && parsed > 0) return parsed;
    }

    return NaN;
  }

  var MIN_INSTALLMENT_VALUE_BRL = 80;
  var INSTALLMENTS_MIN_VALUE = resolvePagBrasilInstallmentMinValue();
  if (!Number.isFinite(INSTALLMENTS_MIN_VALUE) || INSTALLMENTS_MIN_VALUE <= 0) {
    INSTALLMENTS_MIN_VALUE = MIN_INSTALLMENT_VALUE_BRL;
  } else if (INSTALLMENTS_MIN_VALUE < MIN_INSTALLMENT_VALUE_BRL) {
    INSTALLMENTS_MIN_VALUE = MIN_INSTALLMENT_VALUE_BRL;
  }
  var INSTALLMENTS_DEFAULT_MAX = parseInt(
    window.theme &&
    window.theme.settings &&
    window.theme.settings.priceInstallments,
    10
  );
  if (!Number.isFinite(INSTALLMENTS_DEFAULT_MAX) || INSTALLMENTS_DEFAULT_MAX < 1) {
    INSTALLMENTS_DEFAULT_MAX = 10;
  }
  var pricingCache = {};
  var pricingPending = {};

  function formatBRLMoney(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(value);
  }

  function chunkArray(list, chunkSize) {
    var out = [];
    for (var i = 0; i < list.length; i += chunkSize) {
      out.push(list.slice(i, i + chunkSize));
    }
    return out;
  }

  function parseLinePricing(node) {
    if (!node) return { price: 0, compareAt: 0 };

    var qty = parseInt(node.quantity, 10);
    if (!Number.isFinite(qty) || qty <= 0) qty = 1;

    var amountPerQty = node.cost && node.cost.amountPerQuantity && parseFloat(node.cost.amountPerQuantity.amount);
    var comparePerQty = node.cost && node.cost.compareAtAmountPerQuantity && parseFloat(node.cost.compareAtAmountPerQuantity.amount);

    var lineDiscount = 0;
    (node.discountAllocations || []).forEach(function (allocation) {
      var amount = allocation && allocation.discountedAmount && parseFloat(allocation.discountedAmount.amount);
      if (Number.isFinite(amount) && amount > 0) lineDiscount += amount;
    });

    var discountPerQty = lineDiscount > 0 ? (lineDiscount / qty) : 0;
    var effectivePrice = Number.isFinite(amountPerQty) ? Math.max(0, amountPerQty - discountPerQty) : 0;
    var effectiveCompare = Number.isFinite(comparePerQty) ? comparePerQty : 0;

    if (discountPerQty > 0 && (!effectiveCompare || effectiveCompare <= effectivePrice) && Number.isFinite(amountPerQty) && amountPerQty > effectivePrice) {
      effectiveCompare = amountPerQty;
    }

    return {
      price: effectivePrice > 0 ? effectivePrice : 0,
      compareAt: effectiveCompare > effectivePrice ? effectiveCompare : 0
    };
  }

  function ensureCardBadge(cardPriceContainer) {
    function setImp(node, prop, value) {
      if (!node || !node.style) return;
      node.style.setProperty(prop, value, 'important');
    }

    var cardRoot = cardPriceContainer.closest('.product-block');
    var badgeHost = cardRoot && (
      cardRoot.querySelector('.image-cont .image-label-wrap')
      || cardRoot.querySelector('.image-cont')
      || cardRoot.querySelector('.product-block__image')
    );
    if (!badgeHost) {
      badgeHost = cardPriceContainer;
    }
    if (badgeHost.classList) {
      badgeHost.classList.add('auto-discount-badge-host');
      badgeHost.classList.add('auto-discount-badge-host--card');
    }

    var badge = (cardRoot || badgeHost).querySelector('.auto-discount-badge.auto-discount-badge--card');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'auto-discount-badge auto-discount-badge--card';
      badge.innerHTML = '<span class="auto-discount-badge__text"></span>';
      badgeHost.appendChild(badge);
    } else if (badge.parentNode !== badgeHost) {
      badgeHost.appendChild(badge);
    }

    // Force position on image top-right to avoid theme CSS overrides in collection cards.
    setImp(badge, 'position', 'absolute');
    setImp(badge, 'top', window.matchMedia('(max-width: 989px)').matches ? '10px' : '14px');
    setImp(badge, 'right', window.matchMedia('(max-width: 989px)').matches ? '10px' : '14px');
    setImp(badge, 'bottom', 'auto');
    setImp(badge, 'left', 'auto');
    setImp(badge, 'z-index', '21');

    // image-badge--card positioning is controlled only via CSS (image-badge.css).

    return badge;
  }

  // Promo progressiva (ex.: "PROGRESSIVA 20% a 40%"): cards com
  // data-promo-badge-text (metafield custom.promotion_badge_text no produto ou
  // coleção) mostram o texto do lojista no badge — ex.: "ATÉ 40% OFF" — em vez
  // do percentual calculado pela simulação.
  //
  // Preço: se o card também declara data-promo-min-percent (metafield
  // custom.promotion_discount_percent = desconto do tier MÍNIMO, ex.: 20 para
  // "1 peça = 20%"), o preço exibido vira o preço de 1 peça calculado
  // localmente (base × (1 − pct/100)) — transparente, sem nenhuma chamada de
  // API. Sem o percent, o preço cheio do Liquid fica intocado.
  function syncPromoBadges() {
    document.querySelectorAll('.product-price[data-promo-badge-text]').forEach(function (container) {
      var text = (container.getAttribute('data-promo-badge-text') || '').trim();
      if (!text) return;
      var badge = ensureCardBadge(container);
      var badgeText = badge.querySelector('.auto-discount-badge__text');
      if ((badgeText.textContent || '') !== text) {
        badgeText.textContent = text;
      }
      badge.style.display = 'inline-flex';

      var minPct = parseFloat(container.getAttribute('data-promo-min-percent'));
      var baseCents = parseInt(container.getAttribute('data-promo-base-price'), 10);
      if (Number.isFinite(minPct) && minPct > 0 && minPct < 100
        && Number.isFinite(baseCents) && baseCents > 0) {
        var basePrice = baseCents / 100;
        var tierPrice = Math.round(basePrice * (100 - minPct)) / 100;
        applyPriceDisplay(container, { price: tierPrice, compareAt: basePrice });
      }
    });
  }

  function applyPriceDisplay(cardPriceContainer, info) {
    var priceRoot = cardPriceContainer.querySelector('.price');
    if (!priceRoot) return;

    var defaultNode = priceRoot.querySelector('.price__default');
    var currentNode = priceRoot.querySelector('.price__current');
    if (!defaultNode || !currentNode) return;

    var wasNode = priceRoot.querySelector('.price__was');
    if (!wasNode) {
      wasNode = document.createElement('span');
      wasNode.className = 'price__was';
      defaultNode.insertBefore(wasNode, currentNode);
    }

    var formattedPrice = formatBRLMoney(info.price);
    if ((currentNode.textContent || '').trim() !== formattedPrice) {
      currentNode.textContent = formattedPrice;
    }

    if (info.compareAt > info.price) {
      var formattedCompare = formatBRLMoney(info.compareAt);
      if ((wasNode.textContent || '').trim() !== formattedCompare) {
        wasNode.textContent = formattedCompare;
      }
      wasNode.hidden = false;
      priceRoot.classList.add('price--on-sale');
      currentNode.classList.add('discount');
    } else {
      wasNode.textContent = '';
      wasNode.hidden = true;
      priceRoot.classList.remove('price--on-sale');
      currentNode.classList.remove('discount');
    }

    var installmentsNode = priceRoot.querySelector('.ag-price-installments, .price_installments');
    if (installmentsNode) {
      var maxInstallments = INSTALLMENTS_DEFAULT_MAX;
      var installmentsCount = Math.floor(info.price / INSTALLMENTS_MIN_VALUE);
      if (!Number.isFinite(installmentsCount) || installmentsCount < 1) installmentsCount = 1;
      if (installmentsCount > maxInstallments) installmentsCount = maxInstallments;
      installmentsNode.innerHTML = 'Em at&eacute; ' + installmentsCount + 'x de ' + formatBRLMoney(info.price / installmentsCount);
    }

    // PIX price recalc — o preço atualizado em .price__current ainda não
    // refletiu no pix-price renderizado pelo Liquid (preço base original).
    // window.__pixPrice.updateScope (assets/pix-price.js) recalcula final e
    // savings dentro do scope do card. Sem isso, o PIX mostra valor errado
    // em produtos com automatic discount (ex: R$ 479,90 × 0.95 quando o
    // preço final é R$ 335,93).
    var cardRoot = cardPriceContainer.closest('.product-block');
    if (window.__pixPrice && cardRoot) {
      window.__pixPrice.updateScope(cardRoot, info.price);
    }
  }

  function applyPriceToCard(cardPriceContainer, info) {
    if (!cardPriceContainer || !info || !(info.price > 0)) return;

    // Card de promo progressiva: badge e preço (tier mínimo) são geridos por
    // syncPromoBadges(). A simulação de cart em lote (até 40 variants num
    // cart só) faz o desconto por volume retornar sempre o tier MÁXIMO —
    // reescrever o preço aqui anunciaria valor menor do que o cobrado por
    // 1 unidade.
    if ((cardPriceContainer.getAttribute('data-promo-badge-text') || '').trim()) return;

    applyPriceDisplay(cardPriceContainer, info);

    var badge = ensureCardBadge(cardPriceContainer);
    var badgeText = badge.querySelector('.auto-discount-badge__text');
    if (info.compareAt > info.price) {
      var percent = Math.round((1 - (info.price / info.compareAt)) * 100);
      badgeText.textContent = '-' + String(percent) + '%';
      badge.style.display = 'inline-flex';
    } else {
      badgeText.textContent = '';
      badge.style.display = 'none';
    }
  }

  // DEEP-OPT E.5: cache collectCardPriceContainers + byVariant.
  // MutationObserver pode disparar muitas vezes durante interação (swatch toggle,
  // filter change, etc). Sem cache, cada queueSync() faz querySelectorAll do
  // documento inteiro. Em PLP com 24 cards, isso é O(n) repetido em cada mutation.
  // Cache é invalidada em section:load/reorder (já registrados como queueSync
  // listeners) — então tudo que invalida o DOM também invalida o cache.
  var cardCache = null; // { variantId: [cardEls] } | null

  function invalidateCardCache() {
    cardCache = null;
  }

  function collectCardPriceContainers() {
    return Array.from(document.querySelectorAll('.product-price[data-auto-discount-variant-id]')).filter(function (node) {
      var id = String(node.getAttribute('data-auto-discount-variant-id') || '').trim();
      return !!id;
    });
  }

  function syncCards() {
    syncPromoBadges();

    if (!STOREFRONT_TOKEN) return;

    var byVariant;
    if (cardCache) {
      byVariant = cardCache;
    } else {
      var cards = collectCardPriceContainers();
      if (!cards.length) return;

      byVariant = {};
      cards.forEach(function (card) {
        var variantId = String(card.getAttribute('data-auto-discount-variant-id') || '').trim();
        if (!variantId || !/^\d+$/.test(variantId)) return;
        if (!byVariant[variantId]) byVariant[variantId] = [];
        byVariant[variantId].push(card);
      });
      cardCache = byVariant;
    }

    var variantIds = Object.keys(byVariant);
    if (!variantIds.length) return;

    variantIds.forEach(function (variantId) {
      var cached = pricingCache[variantId];
      if (cached && cached.price > 0) {
        byVariant[variantId].forEach(function (card) {
          applyPriceToCard(card, cached);
        });
      }
    });

    var pendingVariantIds = variantIds.filter(function (variantId) {
      return !pricingCache[variantId] && !pricingPending[variantId];
    });
    if (!pendingVariantIds.length) return;

    chunkArray(pendingVariantIds, 40).forEach(function (chunk) {
      chunk.forEach(function (variantId) {
        pricingPending[variantId] = true;
      });

      var query = 'mutation cartCreate($input: CartInput) { cartCreate(input: $input) { cart { lines(first: 50) { edges { node { quantity merchandise { ... on ProductVariant { id } } cost { amountPerQuantity { amount } compareAtAmountPerQuantity { amount } } discountAllocations { discountedAmount { amount } } } } } } userErrors { field message } } }';
      var variables = {
        input: {
          lines: chunk.map(function (variantId) {
            return {
              merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
              quantity: 1
            };
          })
        }
      };

      fetch('/api/2025-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: query, variables: variables })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('automatic discount request failed');
          return response.json();
        })
        .then(function (result) {
          var payload = result && result.data && result.data.cartCreate;
          var errors = payload && payload.userErrors;
          if (errors && errors.length) return;

          var edges = (((payload || {}).cart || {}).lines || {}).edges || [];
          edges.forEach(function (edge) {
            var node = edge && edge.node;
            var merch = node && node.merchandise;
            var rawId = merch && merch.id ? String(merch.id) : '';
            var variantId = rawId.split('/').pop();
            if (!variantId) return;

            var info = parseLinePricing(node);
            if (info.price > 0) {
              pricingCache[variantId] = info;
              var targets = byVariant[variantId] || [];
              targets.forEach(function (card) {
                applyPriceToCard(card, info);
              });
            }
          });
        })
        .catch(function () {
          // fallback: keep default product price rendered by Liquid
        })
        .finally(function () {
          chunk.forEach(function (variantId) {
            delete pricingPending[variantId];
          });
        });
    });
  }

  var rafToken = 0;
  function queueSync() {
    if (rafToken) return;
    rafToken = window.requestAnimationFrame(function () {
      rafToken = 0;
      syncCards();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }

  // Invalidar cache antes de re-sync — DOM mudou
  document.addEventListener('shopify:section:load', function () { invalidateCardCache(); queueSync(); });
  document.addEventListener('shopify:section:reorder', function () { invalidateCardCache(); queueSync(); });
  window.addEventListener('pageshow', function () { invalidateCardCache(); queueSync(); });
  window.addEventListener('popstate', function () { invalidateCardCache(); queueSync(); });

  // DEEP-OPT B.1: scope-down do observer + remove flags caras.
  // - Era: document.body com subtree+attributes+characterData (CPU-hungry)
  // - Agora: #content (pula header/drawers/overlays) sem attributes/characterData
  // - Mantém subtree: true (filter/pagination injetam produtos profundos)
  var observerTarget = document.querySelector('#content') || document.body;
  var observer = new MutationObserver(queueSync);
  observer.observe(observerTarget, {
    childList: true,
    subtree: true
  });

  window.addEventListener('load', queueSync, { once: true });

  // DEEP-OPT B.1: 8 × 800ms = 6.4s (era 40 × 400ms = 16s)
  var retryCount = 0;
  function retrySync() {
    queueSync();
    retryCount += 1;
    if (retryCount < 8) {
      setTimeout(retrySync, 800);
    }
  }
  retrySync();
})();
